export default __webpack_public_path__ + "static/media/asmt-step2.0f4138d6.gif";